module.exports = __webpack_public_path__ + "static/media/resumeCrab-min.d29ff3d9.jpg";